import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";
import Selectfield from "../Merchant/Selectfield";
import DatePickerInput from "../Datepicker";
import Textarea from "../Textarea";
import Button from "../Button";

interface Props {
  onConfirm: any;
  onConfirmClose: any;
}

const ConfirmModal = ({ onConfirm, onConfirmClose }: Props) => {
  return (
    <Modal setOpenOrClose={onConfirmClose} variant={"none"} width="21.2rem">
      <div style={{ padding: "1.5rem 1rem", flexDirection: "column" }}>
        <ModalHeader>
          <HeaderTitle>Alert!</HeaderTitle>
          <Close
            src={require("../../assets/images/ei_close.png")}
            alt="close"
            onClick={onConfirmClose}
          />
        </ModalHeader>
        <ModalBody>
          There are existing bookings for the date you are blocking. Are you
          sure you want to continue with the cancellation? If you decide to
          cancel, the amount will be refunded to users App Wallet
        </ModalBody>
        <ButtonWrapper>
          <Button label="Cancel" onClick={onConfirmClose} />
          <Button
            label="Okay"
            onClick={onConfirm}
            color={Colors.red}
            outlineColor={Colors.red}
            fontColor={Colors.white}
          />
        </ButtonWrapper>
      </div>
    </Modal>
  );
};

const ButtonWrapper = styled.label`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.25rem;
  text-align: center;
  //   gap:0.5rem;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 1rem;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
  text-align: center;
  width: 100%;
`;
const Close = styled.img`
  width: 1.5rem;
  justify-self: flex-end;
  //   transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
`;
export default ConfirmModal;
